import { MetaCamelCase, Otoscopy, OtoscopyAssessment } from 'types'
import { useRequest } from '../useRequest'
import { useServiceCountryUrl } from '../useServiceCountryUrl'
import { identity, pick } from 'utils'

enum ApiPathname {
  OTOSCOPIES = '/medical-records/v1/otoscopies',
  OTOSCOPY_ASSESSMENTS = '/medical-records/v1/otoscopies/:otoscopyId/assessments',
}

type GetOtoscopiesQuery = { customerGid: string }
type GetOtoscopiesResponse = { data: Otoscopy[]; meta: MetaCamelCase }

type GetOtoscopiesAsssessmentsQuery = { otoscopyId: string }
type GetOtoscopiesAsssessmentsResponse = { data: OtoscopyAssessment[]; meta: MetaCamelCase }

interface UseHookContext {
  getOtoscopies(query: GetOtoscopiesQuery): Promise<GetOtoscopiesResponse>
  getOtoscopiesAssessments(query: GetOtoscopiesAsssessmentsQuery): Promise<GetOtoscopiesAsssessmentsResponse>
}

const useOtoscopyService = (): UseHookContext => {
  const { url: baseUrl } = useServiceCountryUrl('otoscopy')
  const getOtoscopies = useRequest<GetOtoscopiesQuery, GetOtoscopiesResponse>({
    baseUrl,
    filterQueryToRouteParams: identity,
    filterQueryToSearchParams: pick(['customerGid']),
    pathname: ApiPathname.OTOSCOPIES,
  })

  const getOtoscopiesAssessments = useRequest<GetOtoscopiesAsssessmentsQuery, GetOtoscopiesAsssessmentsResponse>({
    baseUrl,
    filterQueryToRouteParams: identity,
    pathname: ApiPathname.OTOSCOPY_ASSESSMENTS,
  })

  return { getOtoscopies, getOtoscopiesAssessments }
}

export { useOtoscopyService }
